// Settings → Appearance → Link previews (#578): one dropdown per site, for the mirror that makes the card for the links I
// send. The rows come from the server's list (GET /api/link-previews), so the web app holds no host. Saved to the
// account; everyone sees the card my choice made. If the list does not load (an older server), the section is not drawn.
import { useEffect, useState } from "react";
import { linkPreviewChoice, linkPreviewChoices, linkPreviewLabel, type LinkPreviewList } from "@bloom/shared";
import { loadLinkPreviewList, setLinkPreview, useLinkPreviews } from "../linkPreviews.ts";
import { SettingRow } from "./SettingsShell.tsx";

const HELP =
  "Each site has a mirror that makes the card for a link you send. Everyone sees the card your choice makes. Automatic tries the mirrors in order. A mirror you pick goes first, and Automatic follows if it fails. Unmodified asks no mirror: only the site's own tags. Instagram and TikTok give a picture and a link, with no video.";

export function LinkPreviewsSetting() {
  const picked = useLinkPreviews();
  const [list, setList] = useState<LinkPreviewList | null>(null);
  useEffect(() => {
    let live = true;
    void loadLinkPreviewList().then((l) => live && setList(l));
    return () => {
      live = false;
    };
  }, []);
  if (!list) return null;
  return (
    <SettingRow label="Link previews" wide help={`${HELP} Saved to your account.`}>
      <div className="lp-sites">
        {list.sites.map((s) => {
          const value = linkPreviewChoice(picked, s.site);
          return (
            <label key={s.site} className="lp-site">
              <span>{s.name}</span>
              <select className="input" value={value} onChange={(e) => setLinkPreview(s.site, e.target.value)} data-site={s.site}>
                {linkPreviewChoices(s.mirrors, value).map((c) => (
                  <option key={c} value={c}>
                    {linkPreviewLabel(c, s.unmodifiedVideo)}
                  </option>
                ))}
              </select>
            </label>
          );
        })}
      </div>
    </SettingRow>
  );
}
